"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemRenderer = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = require("../../styled/Button");
const IconContainer_1 = require("./components/IconContainer");
const Arrow_1 = require("./components/Arrow");
const Menu_1 = require("../../styled/Menu");
const SubMenu_1 = require("../../styled/SubMenu");
const MenuItemRenderer = ({ label, icon, isActive = false, onTrigger, children, }) => {
    const [isExpanded, setExpanded] = (0, react_1.useState)(false);
    const hasChildren = react_1.Children.count(children) !== 0;
    const isActiveProp = hasChildren
        ? react_1.default.Children.map(children, item => item?.props.isActive)?.some(Boolean)
        : isActive;
    const itemAction = hasChildren
        ? () => setExpanded(expanded => !expanded)
        : () => onTrigger?.();
    // Custom rule to now show parent menu item as active when expanded and children are active
    const showActiveMenuItem = hasChildren
        ? isActiveProp && !isExpanded
        : isActiveProp;
    (0, react_1.useEffect)(() => {
        if (isActiveProp) {
            setExpanded(true);
        }
    }, [isActiveProp]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.Button, { isActive: showActiveMenuItem, onClick: itemAction },
            react_1.default.createElement(IconContainer_1.IconContainer, { icon: icon }),
            react_1.default.createElement(Menu_1.MenuItemLabel, null, label),
            hasChildren && react_1.default.createElement(Arrow_1.Arrow, { isUp: isExpanded })),
        hasChildren && isExpanded && react_1.default.createElement(SubMenu_1.Ul, { "aria-expanded": true }, children)));
};
exports.MenuItemRenderer = MenuItemRenderer;
